import { Add } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useMatch, useNavigate } from 'react-router-dom';

import { catalogItemActions } from 'entities/CatalogItem/model/slices/CatalogItemSlice';
import { categoryActions } from 'entities/Category/model/slices/CategorySlice';
import { getSelectedPropertyId } from 'entities/Property/model/selectors/PropertySelectors';
import { addCatalogItemActions } from 'features/AddCatalogItem/model/slices/AddCatalogItemSlice';
import { addInventoryItemActions } from 'features/AddInventoryItem/model/slices/AddInventoryItemSlice';
import {
    getRouteGlobalCatalog,
    getRoutePropertiesCatalogInventory,
    getRoutePropertiesCatalogInventoryCategories,
    getRoutePropertiesCatalogInventoryItem,
} from 'shared/const/router';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';

export const AddCatalogItemStartButton = memo(() => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const selectedPropertyId = useSelector(getSelectedPropertyId);

    const currentPageIsInventory = useMatch(
        getRoutePropertiesCatalogInventory(':propertyId'),
    );
    const currentPageIsInventoryItem = useMatch(
        getRoutePropertiesCatalogInventoryItem(':propertyId', ':itemId'),
    );

    const onAddNewItem = useCallback(() => {
        if (currentPageIsInventory || currentPageIsInventoryItem) {
            dispatch(addInventoryItemActions.setEditItemMode(true));
            navigate(
                getRoutePropertiesCatalogInventoryCategories(
                    selectedPropertyId,
                ),
            );
        } else {
            dispatch(addCatalogItemActions.setEditItemMode(true));
            navigate(getRouteGlobalCatalog(selectedPropertyId));
        }

        dispatch(catalogItemActions.closeDetailedItem());
        dispatch(categoryActions.clearCategorySelection());
    }, [
        currentPageIsInventory,
        currentPageIsInventoryItem,
        dispatch,
        navigate,
        selectedPropertyId,
    ]);

    return (
        <Button
            data-testid="btn-add-new-item"
            size="small"
            variant="contained"
            onClick={onAddNewItem}
            startIcon={<Add />}
        >
            <Typography typography="openSans.button">
                {t('Add new item')}
            </Typography>
        </Button>
    );
});
